export default __webpack_public_path__ + "static/media/Dot-white.728a2d29.svg";